import { useState, useEffect } from 'react';
import { getPublicConfig } from '../services/admin';

/**
 * Indique si l'inscription est ouverte (configuration publique).
 *
 * `null` tant que la réponse n'est pas arrivée : les appelants distinguent
 * « en cours de chargement » de « fermée », et n'affichent donc ni le bouton
 * d'inscription ni le formulaire de pré-lancement à tort.
 *
 * La requête est mémoïsée au niveau du module : l'en-tête public et le corps de
 * la page consomment la même promesse, là où chaque composant déclenchait
 * jusqu'ici son propre appel à `/config/public`.
 */
let pending: Promise<boolean> | null = null;

function fetchRegistrationEnabled(): Promise<boolean> {
  if (!pending) {
    pending = getPublicConfig()
      .then((response) =>
        response.success && response.data ? response.data.registrationEnabled : false
      )
      .catch(() => false);
  }
  return pending;
}

export function useRegistrationEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;
    fetchRegistrationEnabled().then((value) => {
      if (active) setEnabled(value);
    });
    return () => {
      active = false;
    };
  }, []);

  return enabled;
}
